import type { BookOwner } from "stores/BookStore";
import stores from "stores/stores";

/** Unblocks `user`, or blocks them once the signed-in user confirms. */
export const toggleBlocked = async (user: BookOwner) => {
  const blocked = stores.user.isBlocked(user._id);
  if (
    blocked ||
    confirm(
      `Block ${user.username}? You won't see their texts in the public library.`
    )
  ) {
    await stores.user.setBlocked(user._id, !blocked);
  }
};
